import { AppInitialProps } from 'next/app'
import {
  FirebaseConfiguration,
  initializeFirebaseWeb
} from "services/browser/FirebaseWeb";
import { removeServersideStylesInBrowser } from "services/shared/MaterialUI";
import { initializePageProgressBar } from "components/shared/PageProgressBar";

export interface NextAppProps extends AppInitialProps {
  firebaseConfig: FirebaseConfiguration;
  visitorIsFromIndia: boolean;
  apolloClient?: any;
}

export function initializeServicesInBrowser() {
  initializeFirebaseWeb();
  initializePageProgressBar();
}

export function manipulateDomInBrowser() {
  removeServersideStylesInBrowser();
}